import { render, staticRenderFns } from "./Promotion_Component.vue?vue&type=template&id=369374a6&scoped=true"
import script from "./Promotion_Component.vue?vue&type=script&lang=js"
export * from "./Promotion_Component.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "369374a6",
  null
  
)

export default component.exports